import { format } from "date-fns";
export function isYearSelected(selectedMonth, year) {
    const date = new Date(selectedMonth);
    date.setFullYear(selectedMonth.getFullYear() + year);
    return selectedMonth.getFullYear() === date.getFullYear();
}
export function getNextYearByDateAndYearOffset(selectedMonth, year) {
    const date = new Date(selectedMonth);
    date.setFullYear(selectedMonth.getFullYear() + year);
    return String(date.getFullYear());
}
export function formatDate(date, dateFormat) {
    if (!date) {
        return "";
    }
    return format(date, dateFormat);
}
export function getWeekDayNames(weekdayNamesShort, weekStartsOn) {
    const copy = [...weekdayNamesShort];
    const chunk = copy.splice(0, weekStartsOn);
    return [...copy, ...chunk];
}
